let globalCombinationCounter = 0;

export function syncCombinationConnectionCounter(connection: number): void {
    globalCombinationCounter = Math.max(globalCombinationCounter, connection);
}

export function getNextCombinationConnection(): number {
    globalCombinationCounter += 1;
    return globalCombinationCounter;
}
